import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import { NowRangeSlider } from '@now/dpl';

@Component({
  selector: 'now-wbsuche-lib-range-slider',
  imports: [],
  templateUrl: './range-slider.component.html',
  styleUrl: './range-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeSliderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('rangeSliderElement')
  rangeSliderElement!: ElementRef<HTMLDivElement>;

  @Input({ required: true })
  value: number | undefined = undefined;

  @Input({ required: true })
  identifier!: string;

  @Input({ required: true })
  range: string[] = [];

  @Input({ required: true })
  label!: string;

  @Input()
  labelFunction: (val: string) => string = (val: string) => val;

  @Output()
  changed = new EventEmitter<any>();

  private rangeSlider?: NowRangeSlider;

  ngAfterViewInit(): void {
    this.rangeSlider = NowRangeSlider.init(this.rangeSliderElement.nativeElement);
  }

  ngOnDestroy(): void {
    this.rangeSlider?.dispose();
  }
}
